import * as React from "react";
import { SVGProps } from "react";

const Pumapay = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 348 252" {...props}>
    <path
      fill="#1e69ff"
      d="M35.8 134.3 0 252.6h76.9l35.8-118.3H35.8zM270.2 0h-95.4l-24.1 78.7h85.7c15.2 0 24 12.5 19.3 27.8s-21 27.8-36.3 27.8h-85.8l-1.6 5.1-22.4 73.6H205c58.7 0 121.1-47.8 139-106.4C362 47.7 328.9 0 270.2 0ZM153.8 0h-77l-24 78.7h77l24-78.7z"
    />
  </svg>
);

export default Pumapay;
